export default __webpack_public_path__ + "static/media/driving_distance.8120bdb7.svg";